/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Grid, Typography2, breakpoints } from '@coursera/cds-core';

import _t from 'i18n!nls/enterprise-learning-path-description-page';

type Props = {
  productTitle: string;
  productType: string;
  description: string;
  primaryCta: React.ReactNode;
  imageUrl: string;
};

const styles = {
  heroWrapper: css`
    padding: 32px 0;
  `,
  contentContainer: css`
    ${breakpoints.down('xs')} {
      text-align: center;
    }
  `,
  title: css`
    margin-bottom: 8px;
  `,
  type: css`
    margin-bottom: 16px;
  `,
  description: css`
    margin-bottom: 32px;
  `,
  imageContainer: css`
    text-align: right;

    ${breakpoints.down('xs')} {
      text-align: center;
      justify-content: center;
      margin-bottom: var(--cds-spacing-300);
      order: -1;
    }
  `,
};

const HeroModule = ({ productTitle, productType, description, primaryCta, imageUrl }: Props) => {
  return (
    <Grid container css={styles.heroWrapper}>
      <Grid item xs={12} sm={8} direction="column" css={styles.contentContainer}>
        <Typography2 variant="titleSmall" component="h1" css={styles.title}>
          {productTitle}
        </Typography2>
        <Typography2 variant="bodySecondary" color="supportText" component="p" css={styles.type}>
          {productType}
        </Typography2>
        <Typography2 variant="bodyPrimary" component="p" css={styles.description}>
          {description}
        </Typography2>
        {primaryCta}
      </Grid>
      <Grid item xs={12} sm={4} justifyContent="flex-end" alignItems="center" css={styles.imageContainer}>
        <img height={240} src={imageUrl} alt={_t('Learning path badge')} />
      </Grid>
    </Grid>
  );
};

export default HeroModule;
